import React from 'react';
import './HomeStyle.scss';
import BannerView from './BannerView';
import JobView from './JobView';
import TestimonialView from './TestimonialView';
import { Link } from 'react-router-dom';


import about_us from '../../assets/images/about-us.png';
import work_icon_01 from '../../assets/images/why-work-icon01.png';
import work_icon_02 from '../../assets/images/why-work-icon02.png';
import work_icon_03 from '../../assets/images/why-work-icon03.png';
import work_icon_04 from '../../assets/images/why-work-icon04.png';
import work_icon_05 from '../../assets/images/why-work-icon05.png';
import refimage from '../../assets/images/reference-img.png';
import aboutbuttom from '../../assets/images/about-bg-bottom.png';
import ready_to_help from '../../assets/images/ready-to-help.png';
import { Navigate } from 'react-router-dom';
import PostJobModalView from '../../common/input/postjobModal/PostJobModalView';

const HomeView = (props) => {
    return (
        <>
            {/* <BannerView 
                modal_show={props.modal_show}
                hideCalculator={props.hideCalculator}
                showCalculator={props.showCalculator}
            />
            <JobView /> */}
            

            <section id="cc-about_us" className="common-padding">
                <div className="container">
                    <div className="cc-aboutus_wrapper">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="cc-aboutus_left">
                                    <h2 className="cc-main_title">About <span className="highlighted">Us</span></h2>
                                    <p>
                                        Carer Connect is a one stop platform for all hiring and job related information in the medical and health sector of the country. It is one of its kind dedicated platform for healthcare jobseekers and recruiters to meet.
                                    </p>
                                    {/* <Link to="/about-us"><button type="button" className="btn btn-border bold">Learn More</button></Link> */}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="cc-aboutus_right">
                                    <img src={about_us} alt="about us image" className="cc-aboutus_img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="cc-top_talent">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 col-lg-6 d-sm-none d-md-block"></div>
                        <div className="col-md-7 col-lg-6">
                            <div className="top_talent-right">
                                <h2 className="cc-main_title">Recruit Top Talent <span className="highlighted">Through Us</span></h2>
                                <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate</p>
                                {/* <Link to="/job-post"><button type="button" className="btn btn-white bold">Post a Job</button></Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="cc-why_work" className="common-padding">
                <div className="container">
                    <h2 className="cc-main_title text-center">Why Work <span className="highlighted">For Us</span></h2>
                    <div className="cc-whyWork_wrapper">
                        <div className="cc-whyWork_box--wrapper">
                            <div className="cc-whyWork_box first">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_01} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">We’re bigger then you think.</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                            <div className="cc-whyWork_box second">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_02} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">Our spirit of adventure</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                            <div className="cc-whyWork_box three">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_03} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">Growing Fast</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                            <div className="cc-whyWork_box four">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_03} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">Valued for who you are</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                            <div className="cc-whyWork_box five">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_05} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">We love what we do</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                            <div className="cc-whyWork_box six">
                                <div className="cc-whyWork_box--inner">
                                    <img src={work_icon_04} alt="why work icon" />
                                    <h3 className="cc-whyWork_box--title">Great place to work</h3>
                                    <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="cc-reference" className="pd-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="cc-reference_left">
                                <h2 className="cc-main_title">Reference</h2>
                                <p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non  mauris vitae erat</p>
                                <button type="button" className="btn btn-border bold">More Reference</button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="cc-reference_right">
                                <img className="cc-reference_img" src={refimage} alt="Reference image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="circle-right"><img src={aboutbuttom} alt="reference background image" /></div>
            </section>

            {/* <TestimonialView /> */}

            <section id="cc-contact_info" className="common-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="cc-contact_left">
                                <h4 className="cc-main_title--md">Contact Info</h4>
                                <ul className="contact-info_list">
                                    <li><i className="fa fa-map-marker" aria-hidden="true"></i> <span>Ballymaley Business Park, Ballymaley, Ennis, Co. Clare, V95 XD79</span></li>
                                    <li><i className="fa fa-phone" aria-hidden="true"></i><a href="tel:+353 (0) 65 6869300">+353 (0) 65 6869300</a></li>
                                    <li><i className="fa fa-location-arrow" aria-hidden="true"></i> <a href="mailto:info@carerconnect.com">info@carerconnect.com</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="cc-contact_right">
                                <div className="cc-gmap">
                                    <iframe id="g-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2408.0904983964965!2d-8.963072384179286!3d52.874784879882895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x485b6d61328f2461%3A0x743c37788d1b355b!2sBallymaley%20Business%20Park%2C%20Gort%20Rd%2C%20Drumgranagh%2C%20Ennis%2C%20Co.%20Clare%2C%20Ireland!5e0!3m2!1sen!2sin!4v1597910386695!5m2!1sen!2sin" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cc-help_img">
                    <img src={ready_to_help} alt="ready to help image" />
                </div>
            </section>
            {/* <PostJobModalView
                hidePostJobModal={props.hidePostJobModal}
                post_modal_show={props.post_modal_show}
            /> */}
             
        </>
    )


}

export default HomeView;